// topbar with logo and links using tailwind css
import React from 'react';
import './App.css';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import logo from './binary.svg';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom';

function Topbar() {
    return (      
        <Disclosure as="nav" className="fixed z-50 bg-gray-300 text-white w-full">
            <div className="hidden md:block">
                <div className="grid grid-cols-2">
                    <div className="justify-self-start mx-2">
                        <Link to="/">
                        <img src={logo} className="w-40 fill-current" alt="logo" />
                        </Link>
                    </div>
                    <div className="justify-self-end mt-3 mr-1">
                        <a href="/culture" className="train-one-regular m-2 text-black">Culture</a>
                        <a href="/services" className="train-one-regular m-2 text-black">Services</a>
                        <a href="/insights" className="train-one-regular m-2 text-black">Insights</a>
                        <a href="/community" className="train-one-regular m-2 text-black">Build</a>
                        <Link to="/contact" className="train-one-regular mx-2 mr-3 text-black">Contact</Link>
                    </div>
                </div>  
            </div>
            <div className="mr-2 md:hidden">
                <div className="grid grid-cols-2">
                    <div className="justify-self-start mx-2">
                        <Link to="/">
                        <img src={logo} className="w-40 fill-current" alt="logo" />
                        </Link>
                    </div>
                    <div className="justify-self-end mt-2">
                        {/* Mobile menu button */}
                        <DisclosureButton className="group relative inline-flex items-center justify-self-end rounded-md p-2 text-black hover:bg-gray-500/75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-600">
                            <span className="absolute -inset-0.5" />
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" />
                            <XMarkIcon aria-hidden="true" className="hidden size-6 group-data-[open]:block" />
                        </DisclosureButton>
                    </div>
                </div>  
            </div>

            {/* Mobile menu */}
            <DisclosurePanel className="z-50 md:hidden">
                <div className="flex flex-col items-center">
                    <a href="/culture" className="train-one-regular m-2 text-black">Culture</a>
                    <a href="/services" className="train-one-regular m-2 text-black">Services</a>
                    <a href="/insights" className="train-one-regular m-2 text-black">Insights</a>
                    <a href="/community" className="train-one-regular m-2 text-black">Build</a>
                    <Link to="/contact" className="train-one-regular m-2 text-black">Contact</Link>
                </div>
            </DisclosurePanel>


            {/* <div className="justify-self-end">
                 <svg
                     xmlns="http://www.w3.org/2000/svg"
                     className="h-6 w-6 m-2"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke="black"
                 >
                     <path
                         strokeLinecap="round"
                         strokeLinejoin="round"
                         strokeWidth={4}
                         d="M4 6h16M4 12h16m-7 6h7"
                     />
                 </svg>
             </div> */}
        </Disclosure>
    );
    }

export default Topbar;